// Shared helpers for the browser-stored auth session.

export const SESSION_KEYS = ["token", "user", "googleUser", "last_company_id"];

export function clearSession() {
  SESSION_KEYS.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch {
      // storage unavailable; nothing to clear
    }
  });
}

export function readStoredJson(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null || raw === "" || raw === "undefined" || raw === "null") {
      return fallback;
    }
    const parsed = JSON.parse(raw);
    return parsed ?? fallback;
  } catch {
    return fallback;
  }
}
